import styled, { css } from 'styled-components/macro'

import { theme, fluidSystem, mediaM } from 'styled'

export const Root = styled.div`
  ${fluidSystem};
  position: relative;
  width: 100%;
  height: 100%;

  > .Inner {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    ${mediaM`
      justify-content: center;
    `};

    @media screen and (max-height: 800px) {
      justify-content: flex-start;
    }
  }
`

export const Chart = styled.div`
  ${fluidSystem};
  flex: 0 999 100%;
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ leaving, entering, navDirection }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(${(leaving ? -50 : entering ? 50 : 0) * navDirection}%, 0);
    transition: all 0.3s ${navDirection * 0.2 + (leaving ? 0.3 : 0.4)}s;
  `};
`

export const ChartInner = styled.div`
  position: relative;
  width: 100%;
  height: 40vh;

  svg {
    width: 100%;
    height: 100%;
    pointer-events: none;
    user-select: none;
    overflow: visible;
  }
`
export const LegendBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${mediaM`
    flex-direction: row;
    justify-content: space-between;
  `};
`
export const Legend = styled.div`
  ${fluidSystem};
  border-left: 2px solid;
  margin-bottom: 32px;

  ${({ leaving, entering, nth, navDirection }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(${(leaving ? -50 : entering ? 50 : 0) * navDirection}%, 0);
    transition: all 0.3s ${navDirection * nth * 0.05 + (leaving ? 0.3 : 0.4)}s;
  `};

  ${mediaM`
    margin-bottom: 0;
  `};
`
export const AxisLine = styled.path.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  stroke-width: 1px;
  stroke: #6d6d6d;
  fill: none;
`

export const GuideLine = styled.path.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  stroke-width: 1px;
  stroke: #dbdbdb;
  stroke-dasharray: 2px 2px;
  fill: none;
`

export const OptionGroup = styled.g.attrs({
  vectorEffect: 'non-scaling-stroke',
})`
  path {
    stroke-width: 2px;
    stroke: ${({ color }) => theme.colors[color]};
    fill: none;
    transition: stroke 0.25s;
  }
  circle {
    fill: ${({ color }) => theme.colors[color]};
    transition: fill 0.25s;
  }
  text {
    fill: ${({ color }) => theme.colors[color]};
  }
`
export const GuideText = styled.text`
  font-size: 10px;
  fill: ${theme.colors.darkGrey};
  user-select: none;

  ${mediaM`
    font-size: 16px;
  `};
`
